import { render, staticRenderFns } from "./TalkBox.vue?vue&type=template&id=302a1783&scoped=true"
import script from "./TalkBox.vue?vue&type=script&lang=js"
export * from "./TalkBox.vue?vue&type=script&lang=js"
import style0 from "./TalkBox.vue?vue&type=style&index=0&id=302a1783&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a1783",
  null
  
)

export default component.exports